import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, RotateCcw } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

const CARD_REVEAL = {
  initial: { opacity: 0, y: 16 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4 },
};

const CHECK_POP = {
  initial: { scale: 0 },
  animate: { scale: 1 },
  transition: { delay: 0.15, type: "spring", stiffness: 200, damping: 14 },
};

export default function Success() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-slate-50 pde-grid-bg">
      <header className="border-b border-slate-200 bg-white/90 backdrop-blur-md">
        <div className="mx-auto flex max-w-[640px] items-center px-5 py-3.5">
          <img src={LOGO_URL} alt="Place des Énergies" className="h-12 w-auto" />
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center px-5 py-12">
        <motion.div
          {...CARD_REVEAL}
          className="w-full max-w-[460px] rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm"
          data-testid="success-card"
        >
          <motion.div
            {...CHECK_POP}
            className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100"
          >
            <Check className="h-10 w-10 text-emerald-600" strokeWidth={3} />
          </motion.div>

          <h1 className="font-heading text-2xl font-bold text-foreground sm:text-3xl">Demande envoyée !</h1>
          <p className="mt-3 text-[15px] text-muted-foreground">
            Merci. Votre fiche a bien été transmise à <span className="font-semibold text-foreground">Place des Énergies</span>.
            Notre conseillère vous recontactera <span className="font-semibold text-foreground">sous 48h ouvrées</span>.
          </p>

          <div className="mt-8 space-y-3">
            <button
              type="button"
              data-testid="new-form-button"
              onClick={() => navigate("/formulaire")}
              className="flex h-12 w-full items-center justify-center gap-2 rounded-full border border-slate-300 bg-white text-sm font-semibold text-slate-700 transition-colors hover:bg-slate-50"
            >
              <RotateCcw className="h-4 w-4" />
              Remplir une nouvelle fiche
            </button>
          </div>
        </motion.div>
      </main>
    </div>
  );
}
